import React from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Avatar, Grid, Typography } from "@material-ui/core";

const EntityDetailsHeader = ({ Icon, title, classes, subtitle, children }) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      className={classes.root}
    >
      <Grid container item xs spacing={2} alignItems="center">
        <Grid item>
          <Avatar>{Icon}</Avatar>
        </Grid>
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <Typography color="inherit" className={classes.text}>
                {title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography color="inherit" variant="caption">
                {subtitle}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{children}</Grid>
    </Grid>
  );
};

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    background: theme.altus.background.header,
    color: theme.palette.getContrastText(theme.altus.background.header),
  },
  text: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(withStyles(styles))(EntityDetailsHeader);
